<nz-date-picker
  class="w-full"
  [nzShowTime]="{ nzFormat: session.settings.timeFormat }"
  [nzFormat]="session.settings.dateFormatFull"
  [formControl]="control"
  nzPlaceHolder="{{ 'add_task.task_delivery_date_placeholder' | translate }}"
></nz-date-picker>
